import {Component, Inject} from '@angular/core';
import {User} from '../../_types/user';
import {AuthService} from '../../_services/auth.service';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'app-badges',
    templateUrl: './badges.component.html',
    styleUrl: './badges.component.scss'
})
export class BadgesComponent {
    confetti: boolean = false;

    constructor(
        private readonly authService: AuthService,
        @Inject(MAT_DIALOG_DATA) private data: { newBadge?: boolean }
    ) {
        if (data && data['newBadge']) {
            this.confetti = true;
            setTimeout((): void => {
                this.confetti = false;
            }, 5000);
        }
    }

    get currentUser(): User {
        return this.authService.getUser();
    }
}
